<template>
  <section class="section why-choose-us">
    <div class="wrapper">
      <div class="title text-white">
        {{ $t("How it works") }}
      </div>
      <div class="cards-container">
        <div class="line">
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div class="cards">
          <div class="card" v-for="(cardData, index) in cards" :key="index">
            <div class="title large">0{{ index + 1 }}</div>
            <div class="dot"></div>
            <h3 class="title small">
              {{ $t(cardData.title) }}
            </h3>

            <p class="desc card-desc">{{ cardData.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "WhyChooseUs",
  data() {
    return {
      cards: [
        {
          title: "Explore the Collection",
          description:
            "Dive into a wide selection of CS2 skins, sorted by rarity, weapon type, and style to help you find exactly what you need.",
        },
        {
          title: "Choose Your Skin",
          description:
            "Found the one?\nAdd it to your cart and move forward to a quick and easy checkout.",
        },
        {
          title: "Equip Your New Skins",
          description:
            "Get your skins instantly and equip them in-game to show off your style.",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.why-choose-us {
  position: relative;
  z-index: 1;
  padding: 0 16px;
  text-align: center;
  background-image: url("@/assets/img/bg2.webp");
  background-position: center;
  background-size: 1512px;
  background-repeat: no-repeat;

  .wrapper {
    max-width: 1512px;
    padding: 70px 0;
  }
}

.cards {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  max-width: 1150px;
  margin: 0 auto;
}
.cards-container {
  position: relative;
  margin-top: 40px;

  .dot {
    width: 16px;
    height: 16px;
    border-radius: 100%;
    background: #9d1616;
  }
  .line {
    width: 100%;
    height: 3px;
    background: #9d1616;
    top: 125px;
    left: 0;
    position: absolute;
    .dot {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      &:last-child {
        left: auto;
        right: 0;
      }
      &:last-child {
        left: auto;
        right: 0;
      }
    }
  }
}
.card {
  position: relative;
  flex: 1;
  max-width: 314px;

  .dot {
    margin: 23px auto 36px;
  }
  .title.large {
    color: #9d1616;
  }
  .title.small {
    font-size: 20px;
  }
}

.card-desc {
  white-space: pre-line;
  margin-top: 20px;
  opacity: 0.5;
  position: relative;
}
@media (max-width: 1200px) {
  .why-choose-us .wrapper {
    padding: 50px 0;
  }
  .hero-image {
    display: none;
  }
}

@media (max-width: 992px) {
  .wrapper {
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }

  .left-column,
  .right-column {
    width: 100%;
    margin-top: 0;
    align-items: center;
  }

  .card {
    width: 100%;
    max-width: 440px;
  }
}
@media (max-width: 768px) {
  .case-image {
    display: none;
  }
  .title-container {
    padding: 16px;
    .title {
      text-align: center;
    }
  }
  .uzi-image {
    display: none;
  }
  .cards {
    flex-direction: column;
    align-items: center;
    margin: 0;
    gap: 50px;
    padding: 24px 0;
  }

  .cards-container {
    .line {
      display: none;
    }
    .dot {
      display: none;
    }
  }
}
</style>
